import {
  ClearOutlined,
  EditOutlined,
  WarningOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Modal,
  Space,
  Spin,
  Tooltip,
  Typography,
  message
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler, ordenarVigencias } from '../../utils';
import { instanceRef } from '../../utils/axios';
import VigenciaConfigForm from './componentes/VigenciaConfigForm';

const AseguradoraProductoVigencia = () => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [model, setModel] = useState();
  const [formDisable, setFormDisable] = useState(false);
  const [vigencias, setVigencias] = useState([]);
  const [vigenciaHabilitadaIdList, setVigenciaHabilitadaIdList] = useState([]);
  const [modalidadHabilitadaIdList, setModalidadHabilitadaIdList] = useState(
    []
  );
  const [modalVisible, setModalVisible] = useState(false);

  const {
    params: { id }
  } = useRouteMatch();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setFormDisable(true);
      const response = await instanceRef.instance.post(
        `aseguradoraproducto/vigencia/${id}`,
        values
      );
      await loadModel();
      setLoading(false);
      if (response?.data?.data) {
        let messageSuccess = 'Actualizado correctamente';
        if (response.data?.data.mensaje) {
          messageSuccess = `${messageSuccess} - ${response.data?.data.mensaje}`;
        }
        message.success(messageSuccess);
      }
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const loadModel = async () => {
    try {
      setLoading(true);

      const response = await instanceRef.instance.get(
        `aseguradoraproducto/vigenciaconfig/${id}`
      );
      const data = response.data?.data;
      if (data) {
        const aseguradoraProducto = { ...data };
        const {
          id_aseguradora,
          id_producto,
          producto,
          aseguradora,
          agendamiento_max_vigencia_cantidad,
          agendamiento_max_vigencia_unidad,
          aseguradoraProductoVigencia,
          calculo_costo_parametros,
          premio_minimo_poliza_gs,
          premio_minimo_poliza_usd,
          promocion_contado,
          recargo_periodo_corto,
          tasa_descuento_pago_total_multianual,
          cantidad_pagos_sugerida,
          cobertura_max_cantidad,
          cobertura_max_unidad,
          cobertura_min_cantidad,
          cobertura_min_unidad,
          emision_multiperiodo,
          retroactividad_cantidad,
          retroactividad_unidad,
          tasa_interes,
          aseguradoraProductoModalidad
        } = aseguradoraProducto;

        let formData = {
          id,
          id_aseguradora,
          id_producto,
          producto,
          aseguradora,
          agendamiento_max_vigencia_cantidad,
          agendamiento_max_vigencia_unidad,
          aseguradoraProductoVigencia,
          calculo_costo_parametros,
          premio_minimo_poliza_gs,
          premio_minimo_poliza_usd,
          promocion_contado,
          recargo_periodo_corto,
          tasa_descuento_pago_total_multianual,
          cantidad_pagos_sugerida,
          cobertura_max_cantidad,
          cobertura_max_unidad,
          cobertura_min_cantidad,
          cobertura_min_unidad,
          emision_multiperiodo,
          retroactividad_cantidad,
          retroactividad_unidad,
          tasa_interes,
          aseguradoraProductoModalidad
        };
        if (!data.calculo_costo_parametros) {
          formData = {
            ...data,
            calculo_costo_parametros: {
              premio_minimo_poliza_gs: null,
              premio_minimo_poliza_usd: null,
              promocion_contado: null,
              tasa_descuento_pago_total_multianual: null
            }
          };
        }
        setModel({ ...model, ...formData });

        // setModel(formData);
        if (formData.cobertura_max_cantidad) {
          setFormDisable(true);
        }
        setTitle(formData.producto.descripcion);
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const getVigencias = async () => {
    try {
      const response = await instanceRef.instance.get('/vigencia');
      if (response.data?.data) {
        const idAseguradora = model.id_aseguradora;
        const idProducto = model.id_producto;
        const aseguradoraProductoVigenciasResponse = await instanceRef.instance.get(
          `aseguradoraproducto/vigencia/${idAseguradora}/${idProducto}`
        );
        let vigenciaList = [];
        if (aseguradoraProductoVigenciasResponse.data?.data) {
          vigenciaList = response.data?.data.filter(
            (item) =>
              item.codigo !== 'personalizado' &&
              aseguradoraProductoVigenciasResponse.data?.data.find(
                (element) =>
                  element.id_vigencia_pago === item.id && element.habilitado
              )
          );
          setVigenciaHabilitadaIdList(vigenciaList.map((item) => item.id));
        }

        setVigencias(
          ordenarVigencias(
            response.data?.data.filter(
              (item) => item.codigo !== 'personalizado'
            ) || []
          )
        );
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleReset = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.post(
        `/aseguradoraProducto/vigencia/reset/${id}`
      );
      if (response.data) {
        message.success('Actualizado correctamente');
        await loadModel();
      }
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
    setModalVisible(false);
    setLoading(false);
  };

  useEffect(() => {
    if (model) {
      getVigencias();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model]);

  useEffect(() => {
    loadModel();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Card
        title={`Configuración de Vigencia - ${title}`}
        style={{ textAlign: 'left' }}
        extra={[
          <Button
            type="text"
            icon={<ClearOutlined />}
            size="middle"
            key="resetear"
            onClick={() => setModalVisible(true)}
          >
            Resetar valores por defecto
          </Button>,
          <Tooltip title="Editar" key="editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => setFormDisable(false)}
              disabled={!formDisable}
            />
          </Tooltip>
        ]}
      >
        {model &&
          vigencias &&
          vigencias.length > 0 &&
          vigenciaHabilitadaIdList && (
            <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
              <VigenciaConfigForm
                model={model}
                onFinish={onFinish}
                disabled={formDisable}
                vigencias={vigencias}
                esEmpresa={false}
                // vigenciaHabilitadaIdList={vigenciaHabilitadaIdList}
                // setVigenciaHabilitadaIdList={setVigenciaHabilitadaIdList}
                {...{
                  vigenciaHabilitadaIdList,
                  setVigenciaHabilitadaIdList,
                  modalidadHabilitadaIdList,
                  setModalidadHabilitadaIdList
                }}
              />
              <Modal
                title="Confirmación de reseteo"
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                onOk={handleReset}
                type="warning"
              >
                <Space size="middle">
                  <Typography.Text type="warning">
                    <WarningOutlined />
                  </Typography.Text>
                  <p>
                    ¿Está seguro de que desea restablecer los valores por
                    defecto del producto para la Aseguradora y Empresas?
                  </p>
                </Space>
              </Modal>
            </Spin>
          )}
      </Card>
    </ResponsiveContainer>
  );
};

export default AseguradoraProductoVigencia;
